import { FlowType } from '@jerry-serverless/types';

import type { AppData } from '../../types/app_data';

export const isGarageFlow = (appData: AppData) => {
  return !!appData.flowType && isGarageFlowType(appData.flowType);
};

export const isGarageFlowType = (type?: FlowType) => {
  return (
    !!type &&
    [
      FlowType.RepairEstimate,
      FlowType.CarValue,
      FlowType.CarRecall,
      FlowType.Maintenance,
      FlowType.RepairShop,
    ].includes(type)
  );
};
